import { ChevronDown } from "lucide-react";

const HERO_BG = "/images/cami_p1_img1.jpeg";

export default function HeroSection({ onRequestDemo }) {
  const scrollToSection = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      data-testid="hero-section"
      className="hero-bg relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={HERO_BG}
          alt="RF Energy Visualization"
          className="w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-[#0A0A0C]/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        {/* Overline */}
        <p
          className="animate-fade-in text-xs sm:text-sm tracking-[0.3em] uppercase mb-8"
          style={{ color: "#D4AF37", fontFamily: "'Manrope', sans-serif", fontWeight: 600 }}
        >
          The Apex of Aesthetic Technology
        </p>

        {/* Main Title */}
        <h1
          className="animate-fade-in-up animation-delay-200 text-5xl sm:text-6xl lg:text-8xl tracking-tighter font-light leading-[0.95] mb-8"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          <span className="block text-white">Cami X</span>
          <span className="block text-white/40 text-3xl sm:text-4xl lg:text-5xl mt-3 tracking-tight font-extralight">
            by Ellantes
          </span>
        </h1>

        {/* Subtitle */}
        <p
          className="animate-fade-in-up animation-delay-400 text-base sm:text-lg text-white/50 max-w-2xl mx-auto leading-relaxed tracking-wide mb-12"
          style={{ fontFamily: "'Manrope', sans-serif" }}
        >
          All modern RF microneedling modalities unified in a single, masterful device.
          Redefining what's possible in aesthetic technology.
        </p>

        {/* CTAs */}
        <div className="animate-fade-in-up animation-delay-600 flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={() => scrollToSection("#technology")}
            className="gold-btn px-10 py-4 text-xs tracking-[0.2em] uppercase"
            data-testid="hero-explore-btn"
          >
            Explore Capabilities
          </button>
          <button
            onClick={onRequestDemo}
            className="outline-btn px-10 py-4 text-xs tracking-[0.2em] uppercase"
            data-testid="hero-contact-btn"
          >
            Request a Demo
          </button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-12 left-1/2 -translate-x-1/2 z-10 animate-fade-in animation-delay-800">
        <button
          onClick={() => scrollToSection("#technology")}
          className="flex flex-col items-center gap-2 text-white/30 hover:text-[#D4AF37] transition-colors"
          data-testid="scroll-indicator"
        >
          <span className="text-[10px] tracking-[0.3em] uppercase" style={{ fontFamily: "'Manrope', sans-serif" }}>
            Discover
          </span>
          <ChevronDown size={16} className="animate-bounce" />
        </button>
      </div>
    </section>
  );
}
